/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(t,a){return t.at===a.at?null===t.value?1:null===a.value?-1:0:t.at-a.at}export{t as compareByTime};
//# sourceMappingURL=sort.js.map
